
<v-app>
	<v-system-bar v-if="impersonationMode" color="red" height="40px" class="justify-center">
		<v-toolbar-title class="white--text" style="font-weight: bold">Impersonation mode is enabled</v-toolbar-title>
		<v-btn small elevation="2" class="black--text ml-5" color="gray" rounded @click="disableImpersonation">Disable</v-btn>
		<v-btn small elevation="2" class="black--text ml-5" color="gray" rounded @click="handleVerificationFormClick">{{ pageLabelDictionary[currentPage] }}</v-btn>
	</v-system-bar>
	<v-row v-if="type === 'demo'">
		<v-col cols="6">
			<v-select label="Select Industry" :items="industriesList" single-line @change="changeIndustry"></v-select>
		</v-col>
		<v-col v-if="user.locale === 'professional'" cols="6">
			<v-select label="Select Profession" :items="professionsList" single-line @change="changeProfession"></v-select>
		</v-col>
	</v-row>
	<locum-preview-popup :show="showLocumPreviewModal"></locum-preview-popup>
	<component :is="$route.meta.layout || 'div'">
		<router-view />
	</component>

	<wallet-dialog ref="walletDialog"></wallet-dialog>
	<pricing-dialog ref="PricingDialog"></pricing-dialog>
	<MessageDialog ref="MessageDialog"></MessageDialog>
</v-app>
